import { makeStyles } from "@material-ui/core";
import { tesaWhite } from "../../styles/colors";

const useStyles = makeStyles({
  box: {
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: tesaWhite,
    padding: 16,
    width: 400,
  },
});

export default useStyles;
